"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseChat_1 = require("./BaseChat");
const uuid_1 = require("uuid");
const mappers_1 = require("../mappers");
const message_1 = require("../message");
// Stub implementation for filtered chats - users can only search chats they're members of
const filteredChatsChatInfo = {
    fetchChatInfo: () => __awaiter(void 0, void 0, void 0, function* () { return ({ isAborted: true, data: {} }); }),
    getUnreadMessageCount: () => 0,
    getLastMessageRead: () => undefined,
    getIsMember: () => true,
};
class FilteredChat extends BaseChat_1.BaseChat {
    constructor(chatInfo, organizationUser, httpAdapter, socketAdapter, userDirectory) {
        super(chatInfo, httpAdapter, socketAdapter, userDirectory, organizationUser, filteredChatsChatInfo);
        this.wasMessageSearchCleared = false;
        this.didFilterChange = (newFilters) => {
            const filterWasAdded = !this._messages.messageFilters && !!newFilters;
            const existingFilterChanged = this._messages.messageFilters &&
                newFilters &&
                JSON.stringify(newFilters) !==
                    JSON.stringify(this._messages.messageFilters);
            return filterWasAdded || existingFilterChanged;
        };
    }
    markMessageAsRead() {
        // No Op
    }
    init() {
        if (this.removeListeners && this.removeListeners.length > 0) {
            throw new Error("Panic: Listeners should have been destoryed during unmount!!!");
        }
        this.removeListeners.push(this.updateMessageListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.deleteMessageListener(() => {
            this.notifyChange();
        }));
    }
    onSocketAuthSuccess() {
        return __awaiter(this, void 0, void 0, function* () {
            // no op...
        });
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    resendMessage() {
        throw new Error("Panic: re-sending message not supported in filter mode!!!");
    }
    resendAsPriorityMessage() {
        throw new Error("Panic: re-sending message as priority not supported in filter mode!!!");
    }
    canRetryMessage() {
        return false;
    }
    retryFailedMessage() { }
    canRetryEdit() {
        return false;
    }
    retryFailedEdit() { }
    getContextMenu() {
        const messageActions = [
            message_1.MESSAGE_CONTEXT_MENU.INFO,
            message_1.MESSAGE_CONTEXT_MENU.ASK_ACKNOWLEDGEMENT,
            message_1.MESSAGE_CONTEXT_MENU.STAR_MESSAGE,
            message_1.MESSAGE_CONTEXT_MENU.UNSTAR_MESSAGE,
            message_1.MESSAGE_CONTEXT_MENU.COPY,
            message_1.MESSAGE_CONTEXT_MENU.DELETE_MESSAGE,
        ];
        this.isPatientGroup() &&
            messageActions.push(message_1.MESSAGE_CONTEXT_MENU.VISIBLE_TO_PATIENT);
        this.isPatientOrInternalGroup() &&
            messageActions.push(message_1.MESSAGE_CONTEXT_MENU.VISIBLE_TO_PHYSICIAN);
        return messageActions;
    }
    fetchMessages(filters, context) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.didFilterChange(filters) || this.wasMessageSearchCleared) {
                this._messages = (0, BaseChat_1.defaultMessagesData)();
                this.wasMessageSearchCleared = false;
            }
            const messageResponse = yield this.httpAdapter
                .getMessageAdapter()
                .getMessages(this.getChatId(), this.getMessageRequest(filters), context);
            if (!messageResponse.isAborted) {
                const newMessagesList = (0, mappers_1.messagesMapper)(messageResponse.data, this.userDirectory, this.organizationUser.getOrganization(), this.makeMessage.bind(this));
                ({ messages: this._messages, mediaList: this.mediaList } =
                    this.upsertMessages(this._messages, this.mediaList, newMessagesList, (_, newMessaages) => {
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const { messages, mediaList, messageFilters } = newMessaages, restData = __rest(newMessaages, ["messages", "mediaList", "messageFilters"]);
                        return Object.assign(Object.assign({}, restData), { messageFilters: filters });
                    }, "APPEND"));
                this.notifyChange();
            }
        });
    }
    clearMessageSearch() {
        this.wasMessageSearchCleared = true;
    }
    openChat() {
        return __awaiter(this, void 0, void 0, function* () {
            this._messages = (0, BaseChat_1.defaultMessagesData)();
            this.notifyChange();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getTemplateByKey(templateKey) {
        return this.organizationUser.getTemplateByKey(templateKey, this.chatInfo);
    }
}
exports.default = FilteredChat;
